import { Checkbox, makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React from 'react';

type Props = {
  tableName: string;
  isVisible: boolean;
  disabled?: boolean;
  label: string;
  handleToggle: (tableName: string) => void;
};

const Item: React.FC<Props> = ({
  tableName,
  label,
  isVisible,
  disabled = false,
  handleToggle,
}) => {
  const classes = useStyles();

  return (
    <li>
      <label className={classes.label}>
        <Checkbox
          color="primary"
          checked={isVisible}
          className={classes.checkbox}
          disabled={disabled}
          onChange={() => handleToggle(tableName)}
        />
        {label}
      </label>
    </li>
  );
};

const useStyles = makeStyles(theme => ({
  checkbox: {
    padding: theme.spacing(0.75),
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    cursor: 'pointer',
    width: '100%',
  },
}));

export default observer(Item);
